import { useState } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Plus, Minus } from 'lucide-react';
import { useTheme } from "@mui/material/styles";
import { useTranslation } from '../../language';

export const TextInfoBloodComp = ({description, lowtext, lowrec, rangetext, hightext, highrec }) => {

    const theme = useTheme();
    const { t, language } = useTranslation();
    const [openSections, setOpenSections] = useState(new Set());

    const sections = [
      { key: 'low',   label: t("Too_Low"),   text: lowtext,   rec: lowrec },
      { key: 'range', label: t("In_Range"),  text: rangetext, rec: null },
      { key: 'high',  label: t("Too_High"),  text: hightext,  rec: highrec },
    ];

 return (
    <div>

      <Typography variant="subtitle1" sx={{ fontWeight: 400, lineHeight: 1.6, mb: 3 }}>
        {description}
      </Typography>

      {sections.map(({ key, label, text, rec }) => {
        const isOpen = openSections.has(key);
        return (
          <Accordion
            key={key}
            expanded={isOpen}
            onChange={(e, expandedNow) => {
              setOpenSections((prev) => {
                const next = new Set(prev);
                if (expandedNow) next.add(key); else next.delete(key);
                return next;
              });
            }}
            disableGutters
            elevation={0}
            square
            sx={{
              bgcolor: 'transparent',
              boxShadow: 'none',
              '&:before': { display: 'none' },
              borderBottom: `1px solid ${theme.palette.divider}`,
              '&:last-of-type': { borderBottom: 'none' },
            }}
          >
            <AccordionSummary
              expandIcon={isOpen ? <Minus size={18} /> : <Plus size={18} />}
              sx={{ px: 0 }}
            >
              <Typography variant="h6" sx={{ fontWeight: isOpen ? 600 : 400 }}>{label}</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 0 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 400, mb: rec ? 1 : 0 }}>
                {text}
              </Typography>
              {rec && (
                <Box sx={{ border: '1px solid', borderColor: theme.palette.mode === 'light' ? 'grey.300' : 'grey.700', backgroundColor: theme.palette.mode === 'light' ? 'grey.100' : 'grey.900', borderRadius: 2, p: 2 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 400 }}>
                    <strong>Recommendation: </strong>{rec}
                  </Typography>
                </Box>
              )}
            </AccordionDetails>
          </Accordion>
        );
      })}
    </div>
  )
}

export default TextInfoBloodComp;
